module.exports = __webpack_public_path__ + "static/media/29ADMSPC35.e0eee213.jpg";